"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.palette = void 0;
const palette = ["e3b5a4", "82c09a", "334e58", "773344", "d9f4c7", "247ba0", "e2f89c", "7cea9c", "083d77", "b0d7ff"];
exports.palette = palette;
